import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ElementGroupFormComponent} from './element-group-form/element-group-form.component';
import {SharedModule} from '@helpers/modules/shared.module';
import {DynamicFieldsModule} from '@subforms/dynamic-fields/dynamic-fields.module';
import {ElementGroupResolverService} from './services/element-group.resolver.service';
import {ElementGroupNtdDefaultParamsResolverService} from './services/element-group-ntd-default-params.resolver.service';
import {ElementGroupNtdListResolverService} from './services/element-group-ntd-list.resolver.service';
import {ElementGroupTypesDefaultListResolverService} from './services/element-group-types-default-list.resolver.service';
import {ElementGroupTypesDefaultParamsResolverService} from './services/element-group-types-default-params.resolver.service';
import {ElementGroupTechnicalDeviceResolverService} from './services/element-group-technical-device.resolver.service';
import { MethodsSubformComponent } from './components/methods-subform/methods-subform.component';
import {ElementGroupTechnicalCardsDefaultListResolverService} from './services/element-group-technical-cards-default-list.resolver.service';
import {ObjectsCommonComponentsModule} from '../objects-common-components/objects-common-components.module';
import {IconsModule} from '@lab365/icons';

@NgModule({
    declarations: [
        ElementGroupFormComponent,
        MethodsSubformComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        DynamicFieldsModule,
        ObjectsCommonComponentsModule,
        IconsModule,
    ],
    providers: [
        ElementGroupResolverService,
        ElementGroupNtdDefaultParamsResolverService,
        ElementGroupNtdListResolverService,
        ElementGroupTypesDefaultListResolverService,
        ElementGroupTypesDefaultParamsResolverService,
        ElementGroupTechnicalDeviceResolverService,
        ElementGroupTechnicalCardsDefaultListResolverService,
    ]
})
export class ElementGroupModule {
}
